import { render, staticRenderFns } from "./SystemChat.vue?vue&type=template&id=47dc9e9f&scoped=true&"
import script from "./SystemChat.vue?vue&type=script&lang=js&"
export * from "./SystemChat.vue?vue&type=script&lang=js&"
import style0 from "./SystemChat.vue?vue&type=style&index=0&id=47dc9e9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dc9e9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
